var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9746 31.1846C13.9746 29.3922 15.6896 27.8828 17.7262 27.8828H44.9519C46.9884 27.8828 48.7034 29.3922 48.7034 31.1846V52.8823C48.7034 54.6748 46.9884 56.1842 44.9519 56.1842C35.305 57.0332 22.9784 56.7502 17.7262 56.1842C15.6896 56.0898 13.9746 54.6748 13.9746 52.788V31.1846Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1289 26.9289V13.7074C20.1289 9.58765 23.0989 6.23438 26.7396 6.23438H36.3204C39.9611 6.23438 42.9311 9.58765 42.9311 13.7074V26.9289",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8432 27.2181V14.8716C24.645 12.2879 26.1996 10.7891 28.1727 10.7891H35.4454C37.1205 10.7891 37.9491 12.7806 37.9491 14.8716V27.2181",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0801 52.3485C14.0801 55.9743 14.2945 57.7382 17.5101 57.9341C22.8695 58.4241 35.4104 58.4241 40.1267 58.4241C49.0233 58.4241 48.5945 56.1703 48.5945 50.9766",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4828 41.1887C28.1992 40.3443 28.6683 35.0906 32.2333 35.2783C35.5169 35.4659 35.8922 40.3443 32.6086 41.2825C33.2653 43.3465 34.3911 48.2249 34.3911 48.2249H29.6065L31.4828 41.1887Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityLock);
export default __webpack_public_path__ + "static/media/security-lock.c2a928f0523fc61f9cbade4deb44c199.svg";
export { ForwardRef as ReactComponent };